import { Button } from "antd";
import styled from "styled-components";

export const SearchByImageButtonStyle = styled(Button)`
    
    background: rgb(131,58,180);
    background: linear-gradient(90deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%);
`;

